import { render, staticRenderFns } from "./login-overseas.vue?vue&type=template&id=a092d1ac&scoped=true"
import script from "./login-overseas.vue?vue&type=script&lang=js"
export * from "./login-overseas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a092d1ac",
  null
  
)

export default component.exports